import * as i0 from "@angular/core";
var QueryStringParamService = /** @class */ (function () {
    function QueryStringParamService($window) {
        this.$window = $window;
    }
    /**
     * Get a single querystring parameter from the querystring (or from the provided search string)
     * @param name the name of the param
     * @param search optional search string to use instead of the url
     */
    QueryStringParamService.prototype.getQueryStringParam = function (name, search) {
        return this.getQueryStringParams(search)[name.toLowerCase()] || null;
    };
    /**
     * Get an object with every querystring parameter available.
     * @param search optional search string to use instead of the url
     */
    QueryStringParamService.prototype.getQueryStringParams = function (search) {
        if (search === void 0) { search = this.$window.location.search; }
        var searchPairs = search.replace('?', '').replace(/%20/g, ' ').split('&');
        return searchPairs.reduce(function (acc, item) {
            item = item.replace('%22=%22', '%22%3D%22'); // prevent "=" from splitting
            var keyVal = item.split('=');
            var key = keyVal[0];
            var val = acc[key];
            if (key) {
                key = key.toLowerCase();
            }
            if (val !== undefined && val !== null && !Array.isArray(val)) {
                acc[key] = val = [acc[key]];
            }
            if (keyVal.length > 1) {
                if (Array.isArray(val)) {
                    val.push(keyVal[1]);
                }
                else {
                    acc[key] = keyVal[1];
                }
            }
            else {
                if (Array.isArray(val)) {
                    val.push(true);
                }
                else {
                    acc[key] = true;
                }
            }
            return acc;
        }, {});
    };
    QueryStringParamService.ngInjectableDef = i0.defineInjectable({ factory: function QueryStringParamService_Factory() { return new QueryStringParamService(i0.inject("Window")); }, token: QueryStringParamService, providedIn: "root" });
    return QueryStringParamService;
}());
export { QueryStringParamService };
